import {
    Directive,
    ElementRef,
    HostListener,
    Renderer2,
    Input,
    ViewContainerRef,
    TemplateRef,
    NgZone,
  } from '@angular/core';
  
  @Directive({
    selector: '[appFollowMouse]',
  })
  export class FollowMouseDirective {
    @Input() appFollowMouse!: TemplateRef<any>; // Accepts an ng-template reference
    @Input() contextData!: any; // Data for the template context
  
    private tooltip!: HTMLElement;
    private mouseMoveListen: (() => void) | null = null;
  
    constructor(
      private el: ElementRef,
      private renderer: Renderer2,
      private viewContainerRef: ViewContainerRef,
      private ngZone: NgZone
    ) {}
  
    @HostListener('mouseenter') onMouseEnter() {
      this.createTooltip();
    }
  
    @HostListener('mouseleave') onMouseLeave() {
      this.destroyTooltip();
    }
  
    private attachMouseMoveListener() {
      // Only attach mousemove listener when tooltip is visible
      this.ngZone.runOutsideAngular(() => {
        this.mouseMoveListen = this.renderer.listen('document', 'mousemove', (event: MouseEvent) => {
          this.updateTooltipPosition(event);
        });
      });
    }
  
    private detachMouseMoveListener() {
      if (this.mouseMoveListen) {
        this.mouseMoveListen();
        this.mouseMoveListen = null;
      }
    }
  
    private updateTooltipPosition(event: MouseEvent) {
      if (this.tooltip) {
        this.renderer.setStyle(this.tooltip, 'top', `${event.clientY + 15}px`);
        this.renderer.setStyle(this.tooltip, 'left', `${event.clientX + 15}px`);
      }
    }
  
    private createTooltip() {
      if (!this.appFollowMouse) return;
  
      // Create a container div
      this.tooltip = this.renderer.createElement('div');
      this.renderer.setStyle(this.tooltip, 'position', 'fixed');
      this.renderer.setStyle(this.tooltip, 'top', '0');
      this.renderer.setStyle(this.tooltip, 'left', '0');
      this.renderer.setStyle(this.tooltip, 'pointerEvents', 'none');
      this.renderer.setStyle(this.tooltip, 'zIndex', '10000');
  
      // Create the embedded view from the template
      const embeddedView = this.viewContainerRef.createEmbeddedView(this.appFollowMouse, {
        $implicit: this.contextData,
      });
  
      // Append template content to the tooltip
      embeddedView.rootNodes.forEach(node => this.renderer.appendChild(this.tooltip, node));
  
      // Attach tooltip to body
      document.body.appendChild(this.tooltip);
  
      // Attach mousemove listener only when tooltip is visible
      this.attachMouseMoveListener();
    }
  
    private destroyTooltip() {
      if (this.tooltip) {
        this.detachMouseMoveListener();
        this.renderer.removeChild(document.body, this.tooltip);
        this.tooltip = null!;
      }
    }
  }
  